// Qué imagen de una prenda mostrar: la de grilla o la del visor.
//
// ═══════════════════════════════════════════════════════════════════
// POR QUÉ EXISTE ESTE ARCHIVO Y NO SE ESCRIBE `p.foto_mini_url` A MANO
// ═══════════════════════════════════════════════════════════════════
//
// Cada prenda tiene DOS imágenes en Storage desde el 2026-08-25: la de
// 1024px (~124 KB) y la miniatura de 512px (~22 KB). Elegir mal no da
// error, no rompe la pantalla y no se ve: solo cuesta diez veces más.
//
// Medido, con 30.000 usuarios abriendo el armario 10 veces al mes:
// usar la grande en las grillas son US$313/mes; usar la chica, US$37.
//
// Un error que no se ve necesita que la decisión esté en UN solo lugar
// y tenga nombre. Por eso hay dos funciones y no un campo.
//
// ⚠️  LAS DOS CAEN A LA OTRA, Y LAS DOS CAÍDAS SON SEGURAS.
//
//     · Sin miniatura (las 172 prendas anteriores, o una foto cuya
//       miniatura no se pudo generar) `fotoChica` devuelve la grande:
//       se ve bien, sale más cara. Visible y corregible.
//     · Sin grande —que no debería pasar nunca— `fotoGrande` devuelve
//       la chica: el visor abre algo borroso en vez de nada.
//
//     Ninguna de las dos devuelve una imagen equivocada ni un hueco.
//     Es la asimetría de siempre: mostrar de más es un costo, mostrar
//     de menos es un agujero.
//
// ⚠️  DÓNDE VA CADA UNA, MEDIDO EN EL CSS Y NO ADIVINADO POR EL NOMBRE.
//
//     TODO `<img>` de la app usa la chica. El único lugar que usa la
//     grande es el Visor (`setAmpliada`), que ocupa la pantalla entera.
//
//     Eso incluye `.modal-foto`, que suena a foto grande y mide 44×44
//     píxeles, y `.ancla-foto`, que mide 48×48. Clasificarlas por el
//     nombre habría mandado la imagen de 124 KB a un cuadradito de 44.
//     El tamaño lo dice el CSS, no cómo se llama la clase.

/** La de la grilla, la tarjeta, el chip y el modal. */
export function fotoChica(prenda) {
  return prenda?.foto_mini_url || prenda?.foto_url || null;
}

/** La del visor a pantalla completa. */
export function fotoGrande(prenda) {
  return prenda?.foto_url || prenda?.foto_mini_url || null;
}
